export default __webpack_public_path__ + "static/media/dress13.470524fb.jpeg";